import React, { useState } from 'react';
import cn from 'classnames';
import logoWhite from 'assets/img/logo-white.svg';
import {
	Divider,
	AdminNav,
	ProfesionalNav,
	NavButton,
	Icon,
} from '../../../components';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { dropFilters } from '@utils/filters';
interface SideBarProps {
	className: string;
}

export const SideBar = ({ className }: SideBarProps) => {
	const { user, signOut } = useAuth();
	const { t } = useTranslation();
	const [loading, setLoading] = useState(false);

	const handleOnClickSignOut = async () => {
		try {
			setLoading(true);
			await signOut();
		} catch (error) {
			console.log({ error });
		} finally {
			dropFilters();
			setLoading(false);
		}
	};

	return (
		<div
			className={cn(
				'bg-black px-5 py-6 sticky top-0 left-0 h-screen flex flex-col',
				className
			)}
		>
			<div>
				<img
					src={logoWhite}
					className='max-h-[32px]'
					alt=''
				/>
				<Divider className='mt-6 mb-4' />
			</div>
			<div className='flex flex-col justify-between grow'>
				{user.isAdmin ? <AdminNav /> : <ProfesionalNav />}

				<NavButton
					text={t('signOut')}
					icon='Patients'
					handleClick={handleOnClickSignOut}
				/>
			</div>
		</div>
	);
};
